// extracted by mini-css-extract-plugin
export default {"pageNumberText":"PaginationRow_pageNumberText__ZYZno","pageInput":"PaginationRow_pageInput__5TiLM"};